<template>
    <div>
        <CommonPopupFrame :changeBottom="0" :changeHeight="90" :isOpen="isOpen" :closeCompleteAction="() => { closeCompleteAction(PROFILE_BOX_LIST.LICENSE, true, false, false) }">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div @click="closeCompleteAction(PROFILE_BOX_LIST.LICENSE, true, false, false)" style="padding-left: 12px; margin-top: 6px; font-weight: 700; color: #808080; height: 30px; width: 50px;">닫기</div>
            <div v-if="step === 1" @touchmove.stop="() => { }" style="margin-top: 31px; flex: 1; overflow-y: scroll; padding: 0 12px; padding-bottom: 20px;">
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 32px; line-height: 46px;">지도자 등급</div>
                    <div style="margin-top: 15px; font-weight: 500; line-height: 24px;">취득한 지도자 라이선스가 있다면<br>설정할 수 있습니다.</div>
                </div>
                <div style="margin-top: 40px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 4px; color: #808080; line-height: 24px;"><span style="font-weight: 700; color: #210f03;">KFA/AFC </span>지도자 라이선스</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setSelectLicense(each)" :class="selectLicense.includes(each) ? 'active_box' : ''" v-for="each, i in kfa" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            {{ each }}
                        </div>
                    </div>
                </div>
                <div style="margin-top: 16px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 4px; color: #808080; line-height: 24px;"><span style="font-weight: 700; color: #210f03;">UEFA </span>지도자 라이선스</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setSelectLicense(each)" :class="selectLicense.includes(each) ? 'active_box' : ''" v-for="each, i in uefa" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            {{ each }}
                        </div>
                    </div>
                </div>
                <div style="margin-top: 16px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 4px; color: #808080; line-height: 24px;"><span style="font-weight: 700; color: #210f03;">AFC </span>GK/풋살/피트니스</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setSelectLicense(each)" :class="selectLicense.includes(each) ? 'active_box' : ''" v-for="each, i in afc" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            {{ each }}
                        </div>
                    </div>
                </div>
            </div>
            <div @touchmove.stop="() => { }" v-else-if="step === 2" style="flex:1; overflow-y: scroll; padding:12px 12px; display:flex; flex-direction: column">
                <div style="padding-bottom: 40px;" class="explain_container">
                    <div class="title">지도자 등급 인증</div>
                    <div style="margin-top: 16px; line-height: 24px;" class="contents">여러 기관에서 발급받은 지도자 자격증이 있다면<br>수료증 혹은 지도자 자격증 카드를 인증해주세요</div>
                </div>
                <div style="flex:1;">
                    <div style="height:250px; text-align:center;">
                        <img :src="require('@/assets/images/coach_register/coach_regi_cert.png')" style="width:180px;">
                    </div>

                    <div class="label">KFA 지도자 수료증 / 지도자 자격증 카드</div>
                    <div class="file_name" style="line-height: 24px;" :class="[imgSrcArr.length > 0 ? 'active' : '']">{{ imgSrcArr.length > 0 ? fileName : 'pdf, jpg, jpeg, png 형식으로 제출해 주세요.' }}</div>
                    <input type="file" ref="file0" style="display:none;" data-id="file0" @change="checkExtension($event)">
                    <input type="file" ref="file1" style="display:none;" data-id="file1" @change="checkExtension($event)">
                    <input type="file" ref="file2" style="display:none;" data-id="file2" @change="checkExtension($event)">
                    <input type="file" ref="file3" style="display:none;" data-id="file3" @change="checkExtension($event)">
                    <input type="file" ref="file4" style="display:none;" data-id="file4" @change="checkExtension($event)">
                    <div style="display: flex; flex-direction: column;">
                        <div class="add_btn" @click="deleteFile">파일 삭제하기</div>
                        <div style="padding-top: 14px; display: flex; align-items: center; gap: 6px;" class="add_btn" @click="addFile">자격증 추가 <span style="font-weight: 900; font-size: 20px;">+</span></div>
                    </div>
                </div>
                <!-- <div class="btn_wrap">
                    <div class="btn" style="flex:2;" :class="[file0_name ? 'active' : 'inactive']" @click="submit">등록하기</div>
                </div> -->
            </div>
            <div v-if="step === 3" style="flex:1; overflow-y: scroll; padding:12px 12px; display:flex; flex-direction: column">
                <div style="padding-bottom: 40px;" class="explain_container">
                    <div class="title">라이선스를 확인중입니다</div>
                    <div style="margin-top: 16px; line-height: 24px;" class="contents">내용을 검토한 후 정보 등록을 진행하겠습니다<br>인증해주셔서 감사합니다!</div>
                </div>
                <div style="text-align:center;">
                    <img :src="require('@/assets/img/check_license.png')" style="width:131px;">
                </div>
                <div style="margin-top: 160px; font-weight: 500; font-size: 12px; line-height: 20px; text-align: center;">확인 절차에 따라 최대 하루 이상의 시간이 소요될 수 있습니다.</div>
            </div>
            <div v-if="step !== 3" style="height: 90px; padding: 0 12px;">
                <div @click="save" v-if="selectLicense.length !== 0" class="save_btn_active">저장하기</div>
                <div v-else class="save_btn_unactive">저장하기</div>
            </div>
            <div v-else-if="step === 3" style="height: 90px; padding: 0 12px;">
                <div @click="closeCompleteAction(PROFILE_BOX_LIST.LICENSE, true, false, true)" style="background-color: #210f03; color: var(--color-main);" class="save_btn_unactive">확인</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ResponseCode from '../../ResponseCode'
import { PROFILE_BOX_LIST, FORM_MODE } from '@/Constants'
// import { COACH_DOC_COMPLETE } from "@/components/modal/coach/CoachDocComplete";

export default {
    name: 'SettingLicense',
    components: { CommonPopupFrame },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        closeCompleteAction: {
            type: Function,
            default: () => { },
        },
    },
    data() {
        return {
            selectLicense: [],
            kfa: ['AFC P급 지도자', 'AFC A급 지도자', 'AFC B급 지도자', 'AFC C급 지도자', 'KFA D급 지도자'],
            uefa: ['UEFA PRO 지도자', 'UEFA A급 지도자', 'UEFA B급 지도자', 'UEFA C급 지도자'],
            afc: ['AFC GK A급 지도자', 'AFC GK B급 지도자', 'KFA GK C급 지도자', 'AFC 풋살 LV3', 'AFC 풋살 LV2', 'AFC 풋살 LV1', 'AFC 피트니스 LV2', 'AFC 피트니스 LV1', 'KFA 피트니스 코치'],
            PROFILE_BOX_LIST: PROFILE_BOX_LIST,
            file0_name: '',
            step: 1,
            imgSrcArr: [],
            fileName: ''
        }
    },
    methods: {
        addFile() {
            if (this.imgSrcArr.length >= 5) {
                alert('최대 5개까지 업로드 가능합니다.');
                return;
            }

            for (let i = 0; i < 5; i++) {
                if (this.$refs['file' + i].value === '') {
                    this.$refs['file' + i].click();
                    return;
                }
            }
        },
        deleteFile() {
            console.log(this.imgSrcArr)
            for (let i = 0; i < 5; i++) {
                this.$refs[`file${i}`].value = '';
            }
            this.imgSrcArr = []
        },
        checkExtension(e) {
            const input = e.currentTarget;

            if (input.files && input.files[0]) {
                var extension = input.files[0].name.split('.').pop().toLowerCase();

                if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp' || extension === 'mp4' || extension === 'mov' || extension === 'qt') {

                    var reader = new FileReader();
                    reader.onload = (e) => {
                        if (input.files[0].size > 1024 * 1024 * 1024) {
                            input.files[0].value = '';
                            this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.');
                            return;
                        }

                        const data = { src: e.target.result, id: input.getAttribute('data-id'), isFileTag: true, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0, name: input.files[0].name };
                        if (extension === 'mp4' || extension === 'mov' || extension === 'qt') data.src = require('@/assets/this_is_video.png');
                        this.imgSrcArr = [...this.imgSrcArr, data];

                        this.test()
                    }
                    reader.readAsDataURL(input.files[0]);

                } else {
                    this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp, mp4, mov, qt만 업로드 가능합니다.');
                }
            }
        },
        test() {
            this.fileName = ''
            this.fileName = this.imgSrcArr.map(item => item.name).join(' ')
        },
        async submit() {
            if (this.$refs.file0.value === '') {
                this.$GlobalStore.showAlert('수료증/지도자 자격증을 첨부해주세요.');
                return;
            }

            const formData = new FormData();
            formData.append('mode', FORM_MODE.UPDATE);
            formData.append('file1', this.$refs.file0.files[0]);
            formData.append('type', 'coach');
            formData.append('licenses', this.selectLicense.join(','));
            this.$Util.sendEventClick('코치자격증_서류등록');

            this.$GlobalStore.showProgress();
            const res = await this.$Axios.post('/api/player_cert/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            this.$GlobalStore.hideProgress();
            if (res.data.code === ResponseCode.SUCCESS) {
                // this.$GlobalStore.closeLastModal();
                // this.$GlobalStore.addModal('CoachDocComplete', { type: COACH_DOC_COMPLETE.CERT_CHANGE_COMPLETE });
                this.step++
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.hideProgress();
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        setSelectLicense(license) {
            if (this.selectLicense.includes(license)) {
                this.selectLicense = this.selectLicense.filter(item => item !== license)
            } else {
                if (this.selectLicense.length >= 5) {
                    this.$GlobalStore.showAlert('라이선스 등록은 5개 까지만 가능합니다.')
                    return
                }
                this.selectLicense.push(license)
            }
        },
        async save() {
            // this.$GlobalStore.showProgress()

            // const formData = new FormData()
            // formData.append('playstyle', this.selectLicense)

            // const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            // if (res.data.code === ResponseCode.SUCCESS) {
            //     this.selectLicense = ''
            //     this.$GlobalStore.hideProgress()
            //     this.closeCompleteAction(PROFILE_BOX_LIST.PLAY_STYLE, true, false, true)
            // }
            if (this.step === 2) {
                this.submit();
                this.deleteFile();
                return
            }
            this.step++
        }
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.selectLicense = []
                this.step = 1
            }
        }
    },
    created() {
        this.submit = this.$Once(this.submit)
    }
}
</script>

<style scoped>
.common_box {
    padding: 10px;
    border-radius: 12px;
    background-color: #f5f5f5;
    margin-top: 40px;
}

.save_btn_active {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #210f03;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.save_btn_unactive {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #f5f5f5;
    text-align: center;
    color: #d9d9d9;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.active_box {
    background-color: #210f03;
    color: #fff;
}

.explain_container {
    padding: 20px;
}

.title {
    color: #210F03;
    font-weight: bold;
    font-size: 32px;
    text-align: center;
}

.contents {
    color: #210F03;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    margin-top: 10px;
}

.contents2 {
    color: #606060;
    font-size: 12px;
    font-weight: 500;
    margin-top: 10px;
    text-align: center;
}

.label {
    margin-top: 30px;
    color: #210F03;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
}

.file_name {
    color: #BBBBBB;
    border-bottom: 1px solid #EBEBEB;
    padding-bottom: 8px;
}

.file_name.active {
    color: #210F03;
    font-size: 16px;
    font-weight: 500;
}

.add_btn {
    padding: 10px 10px;
    padding-left: 0px;
    display: inline-block;
    color: #699BF7;
    font-size: 14px;
    font-weight: bold;
}

.register_input {
    border: 0px;
    border-radius: 12px;
    height: 48px;
    outline: none;
    background-color: #f5f5f5;
    font-size: 14px;
    font-weight: 500;
    color: #210F03;
    padding-left: 12px;
    padding-right: 30px;
    width: 100%;
}

.btn_wrap {
    display: flex;
    gap: 20px;
}

.btn {
    flex: 1;
    display: grid;
    place-items: center;
    height: 46px;
    border-radius: 12px;
    background-color: #EDEDED;
    font-size: 14px;
    font-weight: bold;
}

.btn.inactive {
    color: #D9D9D9;
    color: #D9D9D9;
}

.btn.active {
    color: white;
    background-color: black;
}

.common_box {
    padding: 12px;
    background-color: #f5f5f5;
    border-radius: 12px;
}
</style>